module.exports = __webpack_public_path__ + "img/features_privacymaster_phone_mobile1.c91ca991.jpg";